import * as moment from "moment";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import {
    ANOPENSCROLL_FONT_FAMILY,
    DEFAULT_CLIENT_FONT_FAMILY,
} from "source/app/services/UI/Fonts/BodyFont";
import { GetWeatherBkgColor } from "./GetWeatherBkgColor";
import { IsWalkableWeather } from "./PirateWeather";

export function GetWeatherRowStyleClass(
    record: IWeatherDataEntity,
    useAnopenscrollFont: boolean
) {
    const isLastRecordOfDay = IsLastRecordOfDay(record.time);
    const isCurrentHour = IsCurrentHour(record.time);
    const hasPassed = HasPassed(record.time);
    const icon = record.icon;
    const isWalkable = IsWalkableWeather(record);

    return StyleClassAuto({
        display: hasPassed ? `none` : `grid`,
        gridTemplateColumns: `repeat(5, minmax(0, 1fr))`,
        opacity: 1,
        borderBottom: isLastRecordOfDay ? `1px solid dimgray` : ``,
        color: `#f7f4ee`,
        fontFamily: useAnopenscrollFont
            ? ANOPENSCROLL_FONT_FAMILY
            : DEFAULT_CLIENT_FONT_FAMILY,
        fontSize: `1em`,
        fontWeight: isCurrentHour ? `bold` : `normal`,
        letterSpacing: `0.035em`,
        lineHeight: 1.2,
        minHeight: `26px`,
        alignItems: `center`,
        padding: `0 8px`,
        textTransform: `uppercase`,
        whiteSpace: `nowrap`,
        overflow: `hidden`,
        background: GetWeatherBkgColor(icon, record.summary),
        borderRadius: 0,
        textShadow: isWalkable ? `0px 0px 10px yellowgreen` : `inherit`,
        ":hover": {
            fontWeight: `bold`,
            border: `1px solid silver`,
        },
    });
}

function IsCurrentHour(timestamp: number) {
    const currentMoment = moment();
    const day = moment.unix(timestamp).day();
    const hour = moment.unix(timestamp).hour();
    return day === currentMoment.day() && hour === currentMoment.hour();
}

function IsLastRecordOfDay(timestamp: number) {
    const hour = moment.unix(timestamp).hour();
    return hour === 23;
}

function HasPassed(timestamp: number) {
    const currentMoment = moment();
    const day = moment.unix(timestamp).day();
    const hour = moment.unix(timestamp).hour();
    return day === currentMoment.day() && hour < currentMoment.hour();
}
